(() => {
  const stateKey = '__repelloPressProofV1';
  if (window[stateKey]) return;
  const measurementId = 'G-Y2XG77J1K1';
  const state = { sent: false, checking: false, timer: null, paused: false, privacyRequested: false, until: Date.now() + 120000 };
  window[stateKey] = state;

  const qa = new URL(window.location.href).searchParams.get('press_proof_qa') === '1';
  const status = (marker, value) => { if (qa && marker) marker.dataset.trackingStatus = value; };
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const getValue = (tag, name) => new Promise((resolve) => {
    const timeout = window.setTimeout(() => resolve(null), 1500);
    tag('get', measurementId, name, (value) => {
      window.clearTimeout(timeout);
      resolve(value == null ? null : String(value));
    });
  });
  const schedule = () => {
    if (state.sent || state.paused || state.timer !== null || Date.now() >= state.until) return;
    state.timer = window.setTimeout(() => {
      state.timer = null;
      send();
    }, 1000);
  };

  const send = async () => {
    if (state.sent || state.checking || state.paused) return;
    let marker;
    try {
      const markers = document.querySelectorAll('[data-repello-press-proof][data-eligible="true"]');
      if (markers.length !== 1) return;
      marker = markers[0];
      const { experimentId, variantId, productId, storefrontLanguage, countryCode, preview } = marker.dataset;
      if (experimentId !== 'repello_press_proof_v1' || countryCode !== 'SE') return;
      if (!['control', 'treatment'].includes(variantId) || !['sv', 'en'].includes(storefrontLanguage)) return;
      if (!/^\d+$/.test(productId)) return;
      const parameters = new URL(window.location.href).searchParams;
      const shopify = window.Shopify;
      const isPreview = preview === 'true' || shopify?.designMode || shopify?.inspectMode
        || shopify?.visualPreviewMode || (shopify?.theme?.role && shopify.theme.role !== 'main')
        || parameters.has('preview_theme_id') || parameters.has('preview_key')
        || Boolean(document.getElementById('preview-bar-iframe'));
      if (isPreview && !qa) return;

      if (!shopify?.customerPrivacy) {
        status(marker, 'waiting_for_consent_api');
        if (!state.privacyRequested && typeof shopify?.loadFeatures === 'function') {
          state.privacyRequested = true;
          shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
            if (!error) send();
          });
        }
        schedule();
        return;
      }
      if (!allowed()) { status(marker, 'waiting_for_consent'); return; }
      if (typeof window.gtag !== 'function') { status(marker, 'waiting_for_existing_google_tag'); schedule(); return; }

      state.checking = true;
      status(marker, 'waiting_for_existing_google_identity');
      const tag = window.gtag.bind(window);
      const [clientId, sessionId] = await Promise.all([getValue(tag, 'client_id'), getValue(tag, 'session_id')]);
      if (state.paused || state.sent || !allowed()) return;
      if (!clientId || !/^\d+$/.test(sessionId || '') || Number(sessionId) <= 0) { schedule(); return; }
      if (!marker.isConnected) return;
      tag('event', qa ? 'experiment_impression_qa' : 'experiment_impression', {
        send_to: measurementId,
        experiment_id: experimentId,
        variant_id: variantId,
        product_id: productId,
        storefront_language: storefrontLanguage,
        page_location: window.location.origin + window.location.pathname,
        page_title: '',
        page_referrer: '',
        ...(qa ? { debug_mode: true } : {})
      });
      state.sent = true;
      if (state.timer !== null) window.clearTimeout(state.timer);
      state.timer = null;
      status(marker, 'queued_to_existing_google_tag');
    } catch {
      status(marker, 'tracking_unavailable');
      schedule();
    } finally {
      state.checking = false;
    }
  };
  const resume = () => {
    state.paused = false;
    state.until = Date.now() + 120000;
    send();
  };
  document.addEventListener('visitorConsentCollected', resume);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') resume(); });
  window.addEventListener('pageshow', resume);
  window.addEventListener('load', resume);
  window.addEventListener('pagehide', () => {
    state.paused = true;
    if (state.timer !== null) window.clearTimeout(state.timer);
    state.timer = null;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', send, { once: true });
  else send();
})();
